import CardTitle from "./CardTitle.jsx";

export default function TeaserTitle(props) {
  // eslint-disable-next-line no-console
  console.warn("<TeaserTitle> is deprecated. Use <CardTitle> instead.");
  return <CardTitle {...props} />;
}
